module.exports = __webpack_public_path__ + "img/img2.516cd7cb.png";